interface Action {
  type: string;
}

const actionReducer = (_state: Action, action: Action): Action => {
  return action;
};

export default actionReducer;
